<template>
<nav>
    <v-navigation-drawer v-model="drawer" app>
      <v-list dense rounded>
      <v-row class="text-center">
        <v-col>
          <Login/>
        </v-col>
      </v-row>
        <v-list-item v-for="sideMenuItem in sideMenuItems" :key="sideMenuItem.title" router :to="sideMenuItem.route">
          <v-list-item-action>
            <v-icon>{{ sideMenuItem.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ sideMenuItem.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list dense rounded>
        <v-list-item>
      <v-switch
        v-model="darkTheme"
        @click="changeTheme"
        color="success"
        hide-details
        class="ma-auto d-flex"
      >
        <template slot="label">
          <span class="text-button">{{ t('nav.darkTheme') }}</span>
        </template>
      </v-switch>
        </v-list-item>
      </v-list>
      <v-list dense rounded>
        <v-list-item>
          <v-btn-toggle v-model="selectedLocale" mandatory dense class="ma-auto">
            <v-btn v-for="locale in availableLocales" :key="locale.value" small :value="locale.value">
              {{ locale.label }}
            </v-btn>
          </v-btn-toggle>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="green darken-2" dark :src="require('@/assets/header-background.jpg')">
        <!-- <v-container class="d-inline-flex align-baseline"> -->
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <!-- <v-toolbar-title class="d-inline-flex"> -->
        <v-container class="pa-0 px-5 text-truncate fitcontent">
          <router-link to="/about" style="text-decoration: none; color: inherit">
            <span class="text-h5 font-weight-bold">{{ t('nav.brandPrimary') }}</span> <span class="text-h5 font-weight-light">{{ t('nav.brandSecondary') }}</span>
          </router-link>
        </v-container>
        <!-- </v-toolbar-title> -->

        <!-- </v-container> -->
        <!-- <v-spacer></v-spacer> -->
        <!-- <v-card> -->
          <!-- <v-tabs centered class="hidden-sm-and-down">
              <v-tab>Главная</v-tab>
              <v-tab>Об автошколе</v-tab>
              <v-tab>Документы</v-tab>
          </v-tabs> -->
        <!-- </v-card> -->

        <v-spacer></v-spacer>
        <v-container class="d-inline-flex fitcontent">
            <v-btn text class="hidden-sm-and-down" router to="/about">{{ t('nav.school') }}</v-btn>
            <v-btn text class="hidden-sm-and-down" router to="/docs">{{ t('nav.docs') }}</v-btn>
        <!-- <v-spacer></v-spacer> -->
            <v-btn text class="hidden-sm-and-down" router to="/events">{{ t('nav.events') }}</v-btn>
            <Dropdown :header="t('nav.categories')" :items="dropdownItems"/>
            <v-btn-toggle v-model="selectedLocale" mandatory dense class="hidden-sm-and-down ml-2">
              <v-btn v-for="locale in availableLocales" :key="locale.value" small :value="locale.value">
                {{ locale.label }}
              </v-btn>
            </v-btn-toggle>
            <Login :hiddenOnMobile="true"/>
        </v-container>
    </v-app-bar>
    <v-snackbar
      v-model="snackbar"
      rounded
      :top="$vuetify.breakpoint.xs"
      timeout="7000"
      transition="slide-y-reverse-transition"
    >
      <p class="text-body-1 text-sm-h6 pa-0 ma-0 text-center font-weight-light">
        {{ congratsMessage() }}
      </p>

      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          {{ t('common.close') }}
        </v-btn>
      </template>
    </v-snackbar>
</nav>
</template>

<script>
import Dropdown from './Dropdown'
import Login from './Login'

export default {
    components: {
      Dropdown, Login
    },
    data: () => ({
        foundationYear: 1955,
        drawer: false,
        darkTheme: false,
        snackbar: false,
        availableLocales: [
          { value: 'tr', label: 'TR' },
          { value: 'en', label: 'EN' }
        ]
    }),
    computed: {
      selectedLocale: {
        get() {
          return this.currentLocale
        },
        set(locale) {
          this.$i18n.setLocale(locale)
        }
      },
      sideMenuItems() {
        return [
          { title: this.t('nav.school'), icon: 'mdi-domain', route: '/about' },
          { title: this.t('nav.docs'), icon: 'mdi-file', route: '/docs' },
          { title: this.t('nav.events'), icon: 'mdi-calendar-text', route: '/events' },
          { title: this.t('nav.reviews'), icon: 'mdi-comment-quote-outline', route: '/reviews' },
          { title: this.t('nav.programs'), icon: 'mdi-bag-personal-outline', route: '/docs#course' },
          { title: this.t('nav.paidServices'), icon: 'mdi-toolbox-outline', route: '/docs#paid-service' },
          { title: this.t('nav.regulations'), icon: 'mdi-text-box', route: '/docs#regulations' },
          { title: this.t('nav.localDocs'), icon: 'mdi-file-document-outline', route: '/docs#local' },
        ]
      },
      dropdownItems() {
        return [
            { title: this.t('nav.categoryA'), route: '/about#category-A' },
            { title: this.t('nav.categoryB'), route: '/about#category-B' },
            { title: this.t('nav.categoryC'), route: '/about#category-C' },
            { title: this.t('nav.categoryD'), route: '/about#category-D' },
            { title: this.t('nav.categoryE'), route: '/about#category-E' },
        ]
      }
    },
    mounted() {
      this.darkTheme = localStorage.getItem('theme') === 'dark'
      this.snackbar = !!this.congratsMessage()
    },
    methods: {
      changeTheme() {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark
        localStorage.setItem('theme', this.$vuetify.theme.dark ? 'dark' : 'light')
      },
      congratsMessage() {
        const difference = new Date().getFullYear() - this.foundationYear
        // this.snackbar = difference % 5 == 0
        // console.log(this.snackbar, difference % 5 == 0)
        return (difference % 5 === 0) && this.t('nav.anniversary', { years: difference })
      }
    },
}
</script>

<style>
.fitcontent {
    max-width: fit-content !important;
}
</style>